import Vue from 'vue';
import Router from 'vue-router';
import VueMoment from 'vue-moment';

import Accueil from '@/components/Accueil';
import Carte from '@/components/Carte';
import Action from '@/components/Action';

Vue.use(VueMoment);
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Accueil',
      component: Accueil
    },
    {
      path: '/c',
      name: 'Carte',
      component: Carte
    },
    {
      path: '/a',
      name: 'Action',
      component: Action
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js